export const page = {
  initialize () {
    console.log('DEBUG (events) Initializing page modules.')

    return Object.assign({}, MK.page, {
      inventoryCapable: {
        root: true,
        category: true,
        attribute: true
      }
    })
  }
}